import React, { useEffect, useState, createContext } from "react";
import Form from "react-bootstrap/Form";
import { IoHomeOutline } from "react-icons/io5";
import { FaChartBar } from "react-icons/fa";
import { LuAreaChart } from "react-icons/lu";
import * as api from "../../api/api";
import DropdownSearch from "../../Components/DropdownSearch";
import DropdownSearchSingle from "../../Components/DropdownSearchSingle";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { VscSignOut } from "react-icons/vsc";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Button from "react-bootstrap/Button";
import dayjs from "dayjs";
import Modal from "react-bootstrap/Modal";
import config from "../../config/config";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  useNavigate,
  Outlet,
} from "react-router-dom";
import { ModalHeader } from "react-bootstrap";
import Loading from "../../Components/Loading";
import YesNoModal from "../../Components/Modal/YesNoModal";
import pca from "../../index";
import { useLanguage } from "../../Components/Localization/LanguageContext";
import strings from "../../Components/Localization/strings";
import LanguageSwitcher from "../../Components/Localization/LanguageSwitcher";
import checkAuthorization from "../../config/checkAuth";
import { jwtDecode } from "jwt-decode";
import ChooseTenant from "../ChooseTenant";
import ErrorBoundary from "../../Components/ErrorBoundary";

export const IdleCodeContext = createContext(null);

function AgentHomePage(props) {
  let navigate = useNavigate();
  const { language } = useLanguage();
  const pageTitle = "AgentHomePage";
  const [showStatisticsModal, setShowStatisticsModal] = useState(false);
  const [showOfflineModal, setShowOfflineModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [chosenDay, setChosenDay] = useState(
    strings[pageTitle][language].PersonalStatisticsToday
  );
  const [agentIdleCodes, setagentIdleCodes] = useState([]);
  const [isAvailable, setIsAvailable] = useState(false);
  const [currentIdleCode, setCurrentIdleCode] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [userTenant, setUserTenant] = useState({});
  const [choseTenant, setChoseTenant] = useState(false);
  const [userName, setUserName] = useState("");
  const [choseTenantFlag, setChoseTenantFlag] = useState(false);

  let userTenantObj = JSON.parse(sessionStorage.getItem("userTenant"));
  const fetchUser = async () => {
    const tokenObject = await instance.acquireTokenSilent({
      account: instance.getActiveAccount(),
    });

    const token = tokenObject.idToken;
    //console.log(token);

    // const token = sessionStorage.getItem("token");
    const decodedToken = await jwtDecode(token);
    console.log("decoded token is :", decodedToken);
    setUserName(decodedToken.name);
  };
  useEffect(() => {
    if (!userTenantObj) {
      // navigate("/choosetenant");
      //setChoseTenant(false);
    } else {
      if (!choseTenantFlag) {
        setChoseTenant(true);
        setUserTenant(userTenantObj);
        setChoseTenantFlag(true);
      }

      // fetchUser();
    }
  }, [userTenantObj, choseTenant]);

  useEffect(() => {
    if (choseTenantFlag) {
      initialiseFilterItems();
      api.getAgentTenantSettingsById().then((response) => {
        console.log(response.data.object);
        setMinDate(
          dayjs().subtract(
            response.data.object.trackedActivitiesDisplayDurationMonths,
            "months"
          )
        );
      });
      api.getAgentIdleCodes().then((response) => {
        setagentIdleCodes(response.data.object);
      });
      checkAuthorization("AGENT").then((isAuthorized) => {
        if (!isAuthorized) {
          console.log("not authed ******");
          navigate("/agent/unauthorized");
        } else {
          console.log("authed ******");
          fetchUser();
        }
      });
    }
  }, [choseTenant, userTenant]);

  useEffect(() => {
    setChosenDay(strings[pageTitle][language].PersonalStatisticsToday);
  }, [strings[pageTitle][language].PersonalStatisticsToday]);

  const initialiseFilterItems = () => {
    api.getAllAgentServices().then((response) => {
      setServices(response.data.object);
    });
    api.getAllAgentForms().then((response) => {
      setForms(response.data.object);
    });
  };

  const [statisticsData, setStatisticsData] = useState({});
  const [offlineActivities, setOfflineActivities] = useState([]);
  const [minDate, setMinDate] = useState();

  function getFormattedDate(param, date) {
    const today = date;

    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");

    let hours;
    let minutes;
    let seconds;

    if (param === "from") {
      hours = "00";
      minutes = "00";
      seconds = "00";
    } else {
      hours = "23";
      minutes = "59";
      seconds = "59";
    }

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const handleDateFromChange = (date) => {
    const inputDate = new Date(date);

    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = "00";
    const minutes = "00";
    const seconds = "00";

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    handleFetchFilteredProcesses({ startDate: formattedDate });
    setSelectedFromDate(date);
  };

  const [selectedToDate, setSelectedToDate] = useState(dayjs());

  const handleDateToChange = (date) => {
    const inputDate = new Date(date);

    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = "23";
    const minutes = "59";
    const seconds = "59";

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    handleFetchFilteredProcesses({ endDate: formattedDate });

    setSelectedToDate(date);
  };

  const startDateString = getFormattedDate("from", new Date(Date.now()));
  const endDateString = getFormattedDate("to", new Date(Date.now()));
  const [filter, setFilter] = useState({
    startDate: startDateString,
    endDate: endDateString,
    formIds: [],
    serviceIds: [],
    processTypeIds: [1],
    isBillable: null,
  });
  const [services, setServices] = useState([]);
  const [forms, setForms] = useState([]);
  const billableTypes = [
    {
      name: "Billable/Not Billable",
      value: null,
    },
    {
      name: "Billable",
      value: true,
    },
    {
      name: "Not Billable",
      value: false,
    },
  ];
  const finalizedTypes = [
    {
      name: "Finalized/Not Finalized",
      value: null,
    },
    {
      name: "Finalized",
      value: true,
    },
    {
      name: "Not finalized",
      value: false,
    },
  ];
  function formatMillisecondsToTime(milliseconds) {
    // Convert milliseconds to seconds
    let seconds = Math.floor(milliseconds / 1000);

    // Calculate hours, minutes, and remaining seconds
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);
    let remainingSeconds = seconds % 60;

    // Add leading zeros if needed
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    remainingSeconds =
      remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;

    // Return formatted time
    return `${hours}:${minutes}:${remainingSeconds}`;
  }
  const [selectedFromDate, setSelectedFromDate] = useState(dayjs());
  const handleFetchFilteredProcesses = (values) => {
    setLoading(true);
    let searchParts = values;
    try {
      searchParts = {
        [values.split(":")[0]]: values.split(":")[1].split(","),
      };
      if (searchParts.hasOwnProperty("serviceIds")) {
        let idValues = [];
        console.log(searchParts.serviceIds);
        searchParts.serviceIds.forEach((value) => {
          function findIdByName(name) {
            const activity = services.find((service) => service.name === name);
            return activity ? activity.serviceId : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.serviceIds = null;
        } else {
          searchParts.serviceIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("formIds")) {
        let idValues = [];
        searchParts.formIds.forEach((value) => {
          function findIdByName(name) {
            const activity = forms.find((form) => form.name === name);
            return activity ? activity.formId : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.formIds = null;
        } else {
          searchParts.formIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("isBillable")) {
        if (searchParts["isBillable"] == "true") {
          searchParts["isBillable"] = true;
        } else if (searchParts["isBillable"] == "false") {
          searchParts["isBillable"] = false;
        } else {
          searchParts["isBillable"] = null;
        }
      } else if (searchParts.hasOwnProperty("isFinalized")) {
        if (searchParts["isFinalized"] == "true") {
          searchParts["isFinalized"] = true;
        } else if (searchParts["isFinalized"] == "false") {
          searchParts["isFinalized"] = false;
        } else {
          searchParts["isFinalized"] = null;
        }
      }
      console.log(searchParts);
    } catch (e) {
      console.log(e);
      console.log(searchParts);
    }

    const updatedFilter = { ...filter, ...searchParts };
    setFilter(updatedFilter);

    api.getOfflineActivities(updatedFilter).then((response) => {
      console.log(response.data.object);
      console.log("the filter used is: ", updatedFilter);
      console.log("response: ", response.data.object);
      setOfflineActivities(response.data.object);
    });

    /*
    api
      .getOfflineActivitesMyOfflineActivities(updatedFilter)
      .then((response) => {
        console.log(response.data.object);
        console.log("the filter used is: ", updatedFilter);
        const { current, history } = response.data.object;

        console.log("response: ", current, history);
        setOfflineActivities(history);
        setLoading(false);
      });*/
  };

  useEffect(() => {
    document.title = "Cayci - Agent";
  }, []);

  const handleChangingStatisticsDay = (e) => {
    console.log(e.target.name);
    setChosenDay(e.target.name);
    setLoading(true);
    if (
      e.target.name === strings[pageTitle][language].PersonalStatisticsYesterday
    ) {
      const { startDate, endDate } = getStartAndEndYesterDayUTC();
      api.getAllStatistics(startDate, endDate).then((response) => {
        console.log("yesterday stat data ", response.data.object);
        setStatisticsData(response.data.object);
        setLoading(false);
      });
    } else {
      const { startDate, endDate } = getStartAndEndUTC();
      api.getAllStatistics(startDate, endDate).then((response) => {
        console.log("today stat data ", response.data.object);
        setStatisticsData(response.data.object);
        setLoading(false);
      });
    }
  };

  const pad = (timeValue) => {
    return timeValue.toString().padStart(2, "0");
  };
  const formatDuration = (time) => {
    // Convert elapsed time in milliseconds to hours:minutes:seconds format
    let seconds = Math.floor(time / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  function formatDateToUTCString(date) {
    return (
      date.getUTCFullYear() +
      "-" +
      String(date.getUTCMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getUTCDate()).padStart(2, "0") +
      " " +
      String(date.getUTCHours()).padStart(2, "0") +
      ":" +
      String(date.getUTCMinutes()).padStart(2, "0") +
      ":" +
      String(date.getUTCSeconds()).padStart(2, "0")
    );
  }
  function getStartAndEndYesterDayUTC() {
    let now = new Date();
    now.setDate(now.getDate() - 1);
    const startOfDay = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        0,
        0,
        0
      )
    );
    const endOfDay = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        23,
        59,
        59
      )
    );

    return {
      startDate: formatDateToUTCString(startOfDay),
      endDate: formatDateToUTCString(endOfDay),
    };
  }
  function getStartAndEndUTC() {
    const now = new Date();
    const startOfDay = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        0,
        0,
        0
      )
    );
    const endOfDay = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        23,
        59,
        59
      )
    );

    return {
      startDate: formatDateToUTCString(startOfDay),
      endDate: formatDateToUTCString(endOfDay),
    };
  }
  const handleShowStatisticsModal = () => {
    //fetch stats
    setShowStatisticsModal(true);
    setLoading(true);
    const { startDate, endDate } = getStartAndEndUTC();
    api.getAllStatistics(startDate, endDate).then((response) => {
      console.log("stat data ", response.data.object);
      setStatisticsData(response.data.object);
      setLoading(false);
    });
    // then show modal
  };
  // const navigate = useNavigate();
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const handleAgentLogout = () => {
    if (isAuthenticated) {
      window !== window.parent
        ? instance
            .logoutPopup()
            .then(() => {
              // Handle post-logout actions...
              console.log("signed out");
              sessionStorage.removeItem("userTenant");

              navigate("/postLogout");

              // window.location.reload();
            })
            .catch((error) => {
              console.error("coudln't sign out ", error);
            })
        : instance
            .logoutRedirect()
            .then(() => {
              console.log("signed in");
            })
            .catch((error) => {
              console.error("canclled sign in ", error);
            });
    }
    // localStorage.removeItem("token");
    // pca.clearCache();
    // const postLogoutURL = config.postLogoutURL;
    // // const postLogoutURL="https://zealous-cliff-0d4e7570f.4.azurestaticapps.net" //dev
    // const logoutUrl =
    //   "https://login.microsoftonline.com/3f27056d-4d7b-420f-aed8-d0eb1fa914ca/oauth2/logout?post_logout_redirect_uri=" +
    //   postLogoutURL;
    // window.location.replace(logoutUrl);
  };
  return (
    <ErrorBoundary>
      {choseTenant ? (
        <div className="home-page-container">
          <div className="nav-bar">
            <h3
              onClick={() => window.location.reload()}
              style={{
                fontWeight: "bold",
                paddingTop: "0.1em",
                cursor: "pointer",
              }}
            >
              Agent page
            </h3>
            <div className="d-flex flex-wrap gap-1">
              <p className="user-info">{userTenant.name + " / " ?? ""}</p>
              <p className="user-info">{userName}</p>
            </div>
            <div
              className="d-flex gap-2 align-items-center justify-content-center me-4"
              style={{ width: "25%" }}
            >
              <LanguageSwitcher></LanguageSwitcher>
              <h6 style={{ color: "var(--accent-color)", margin: "0" }}>
                IDLE
              </h6>
              <Form.Select
                aria-label="Default select example"
                value={currentIdleCode}
                onChange={(e) => {
                  console.log(e.target.value);
                  setIsAvailable(false);
                  setCurrentIdleCode(e.target.value);
                }}
              >
                {isAvailable && <option value="choose">Choose ...</option>}
                {agentIdleCodes?.map((idleCode) => {
                  return (
                    <option key={idleCode.ctiId} value={idleCode.ctiId}>
                      {idleCode.masterIdle.name}
                    </option>
                  );
                })}
              </Form.Select>
              {/* <button
              className={
                isAvailable ? "idle-status-btn activated-btn" : "idle-status-btn"
              }
              style={{ width: "30%" }}
              onClick={() => {
                setIsAvailable(true);
                setCurrentIdleCode("choose");
              }}
            >
              Available
            </button> */}
            </div>
          </div>
          <div className="main-container">
            <div className="agent-side-bar">
              <NavLink to="/agent">
                <div className="side-bar__option">
                  <IoHomeOutline size={20} />
                </div>
              </NavLink>
              <div
                className="side-bar__option"
                onClick={() => handleShowStatisticsModal()}
              >
                <FaChartBar size={20} />
              </div>
              <div
                className="side-bar__option"
                onClick={() => {
                  setShowOfflineModal(true);
                  handleFetchFilteredProcesses();
                }}
              >
                <LuAreaChart size={25} />
              </div>
              <div
                className="side-bar__option"
                onClick={() => setShowLogoutModal(true)}
              >
                <VscSignOut size={25} />
              </div>
            </div>
            <Modal
              show={showStatisticsModal}
              onHide={() => setShowStatisticsModal(false)}
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {strings[pageTitle][language].PersonalStatisticsHeader}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="d-flex flex-column">
                <Form>
                  <Form.Check
                    onClick={handleChangingStatisticsDay}
                    key={
                      strings[pageTitle][language].PersonalStatisticsYesterday
                    }
                    inline
                    label={
                      strings[pageTitle][language].PersonalStatisticsYesterday
                    }
                    name={
                      strings[pageTitle][language].PersonalStatisticsYesterday
                    }
                    type={"radio"}
                    checked={
                      chosenDay ==
                      strings[pageTitle][language].PersonalStatisticsYesterday
                    }
                    id={`inline-radio-Yesterday`}
                  />
                  <Form.Check
                    onClick={handleChangingStatisticsDay}
                    key={strings[pageTitle][language].PersonalStatisticsToday}
                    inline
                    label={strings[pageTitle][language].PersonalStatisticsToday}
                    name={strings[pageTitle][language].PersonalStatisticsToday}
                    type={"radio"}
                    checked={
                      chosenDay ==
                      strings[pageTitle][language].PersonalStatisticsToday
                    }
                    id={`inline-radio-Today`}
                  />
                </Form>
                <div class="service-details-grid">
                  {isLoading && <Loading />}
                  {/* <div class="grid-item" className="grid-item-title">
                  {strings[pageTitle][language].PersonalStatisticsTotalProcesTime}
                </div>
                <div class="grid-item" style={{ width: "100%" }}>
                  {statisticsData.totalTimeMs
                    ? formatDuration(statisticsData.totalTimeMs)
                    : "00:00:00"}
                </div> */}
                  <div class="grid-item" className="grid-item-title">
                    {
                      strings[pageTitle][language]
                        .PersonalStatisticsNetProcessTime
                    }
                  </div>
                  <div class="grid-item" style={{ width: "100%" }}>
                    {statisticsData.totalProcessTimeMs
                      ? formatDuration(statisticsData.totalProcessTimeMs)
                      : "00:00:00"}
                  </div>
                  {/* <div class="grid-item" className="grid-item-title">
                  {strings[pageTitle][language].PersonalStatisticsTotalIdleTime}
                </div>
                <div class="grid-item" style={{ width: "100%" }}>
                  {statisticsData.totalIdleTimeMs
                    ? formatDuration(statisticsData.totalProcessTimeMs)
                    : "00:00:00"}
                </div> */}
                </div>
                <h6 className="main-content__title" style={{ padding: "0" }}>
                  {
                    strings[pageTitle][language]
                      .PersonalStatisticsOfflineActivities
                  }
                </h6>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    margin: "0 1em 1em 1em",
                  }}
                ></div>
                <table
                  style={{
                    marginLeft: "1em",
                    marginRight: "1em",
                    boxSizing: "content-box",
                  }}
                >
                  <tr>
                    <th>
                      {strings[pageTitle][language].PersonalStatisticsTeam}
                    </th>
                    <th>
                      {strings[pageTitle][language].PersonalStatisticsService}
                    </th>
                    <th>
                      {strings[pageTitle][language].PersonalStatisticsForm}
                    </th>
                    <th>
                      {strings[pageTitle][language].PersonalStatisticsDuration}
                    </th>
                    <th>
                      {strings[pageTitle][language].PersonalStatisticsCount}
                    </th>
                    <th>
                      {strings[pageTitle][language].PersonalStatisticsAht}
                    </th>
                  </tr>
                  {statisticsData.offlineActivities &&
                    statisticsData.offlineActivities.map((process) => {
                      return (
                        <tr key={process.processId}>
                          <td>{process.team}</td>
                          <td>{process.service}</td>
                          <td>{process.form}</td>
                          <td>{formatDuration(process.durationMs)}</td>
                          <td>{process.count}</td>
                          <td>{formatDuration(process.averageDurationMs)}</td>
                        </tr>
                      );
                    })}
                </table>
                <h6
                  className="main-content__title"
                  style={{ padding: "0", marginTop: "2em" }}
                >
                  {
                    strings[pageTitle][language]
                      .PersonalStatisticsCallActivities
                  }
                </h6>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    margin: "0 1em 1em 1em",
                  }}
                ></div>
                <table
                  style={{
                    marginLeft: "1em",
                    marginRight: "1em",
                    boxSizing: "content-box",
                  }}
                >
                  <tr>
                    <th>
                      {
                        strings[pageTitle][language]
                          .PersonalStatisticsTypeOfCall
                      }
                    </th>
                    <th>
                      {strings[pageTitle][language].PersonalStatisticsDuration}
                    </th>
                    <th>
                      {strings[pageTitle][language].PersonalStatisticsCount}
                    </th>
                    <th>
                      {strings[pageTitle][language].PersonalStatisticsAht}
                    </th>
                  </tr>
                  {statisticsData.callActivities &&
                    statisticsData.callActivities.map((process) => {
                      return (
                        <tr key={process.processId}>
                          <td>{process.typeOfCall}</td>
                          <td>{formatDuration(process.durationMs)}</td>
                          <td>{process.count}</td>
                          <td>{formatDuration(process.averageDurationMs)}</td>
                        </tr>
                      );
                    })}
                </table>
                {/* <h6
                className="main-content__title"
                style={{ padding: "0", marginTop: "2em" }}
              >
                {strings[pageTitle][language].PersonalStatisticsIdleAct}
              </h6>
              <div
                style={{
                  borderBottom: "1px solid black",
                  margin: "0 1em 1em 1em",
                }}
              ></div>
              <table
                style={{
                  marginLeft: "1em",
                  marginRight: "1em",
                  boxSizing: "content-box",
                }}
              >
                <tr>
                  <th>
                    {strings[pageTitle][language].PersonalStatisticsIdleCode}
                  </th>
                  <th>
                    {strings[pageTitle][language].PersonalStatisticsDuration}
                  </th>
                  <th>{strings[pageTitle][language].PersonalStatisticsCount}</th>
                  <th>{strings[pageTitle][language].PersonalStatisticsAht}</th>
                </tr>
              </table> */}
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="button-normal"
                  onClick={() => setShowStatisticsModal(false)}
                >
                  OK
                </button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={showOfflineModal}
              onHide={() => setShowOfflineModal(false)}
              size="xl"
            >
              <ModalHeader closeButton>
                <Modal.Title>
                  {strings[pageTitle][language].MyOfflineActivitiesHeader}
                </Modal.Title>
              </ModalHeader>
              <Modal.Body>
                <div className=" mt-2 d-flex gap-1 max-width-800 mx-auto p-3  flex-wrap">
                  <h6
                    className="grid-item-title"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {strings[pageTitle][language].MyOfflineActivitiesFilterBy}{" "}
                  </h6>
                  <DropdownSearch
                    items={services}
                    label="Services"
                    labelText={
                      strings[pageTitle][language].MyOfflineActivitiesServices
                    }
                    triggerSearch={handleFetchFilteredProcesses}
                  ></DropdownSearch>
                  <DropdownSearch
                    items={forms}
                    label="Forms"
                    labelText={
                      strings[pageTitle][language].MyOfflineActivitiesForms
                    }
                    triggerSearch={handleFetchFilteredProcesses}
                  ></DropdownSearch>
                  <DropdownSearchSingle
                    items={strings[pageTitle][language].billableTypes}
                    label="Billable"
                    labelText={
                      strings[pageTitle][language].MyOfflineActivitiesBillable
                    }
                    triggerSearch={handleFetchFilteredProcesses}
                  ></DropdownSearchSingle>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div style={{ width: "150px", marginTop: "0px" }}>
                      <DatePicker
                        label={strings[pageTitle][language].FromDate}
                        onChange={handleDateFromChange}
                        value={selectedFromDate}
                        disableFuture
                        minDate={minDate}
                        format="DD/MM/YYYY" // Specify the desired date format here
                        slotProps={{
                          field: {
                            readOnly: true,
                          },
                        }}
                      />
                    </div>
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div
                      style={{
                        width: "150px",
                        height: "30px",
                        marginTop: "0px",
                      }}
                    >
                      <DatePicker
                        label={strings[pageTitle][language].ToDate}
                        onChange={handleDateToChange}
                        value={selectedToDate}
                        maxDate={dayjs()}
                        minDate={dayjs(selectedFromDate)}
                        format="DD/MM/YYYY" // Specify the desired date format here
                        slotProps={{
                          field: {
                            readOnly: true,
                          },
                        }}
                      />
                    </div>
                  </LocalizationProvider>
                </div>
                <h6 className="main-content__title" style={{ padding: "0" }}>
                  {strings[pageTitle][language].MyOfflineActivitiesTrackedVol}
                </h6>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    margin: "0 1em 1em 1em",
                  }}
                ></div>
                <table
                  style={{
                    marginLeft: "1em",
                    marginRight: "1em",
                    boxSizing: "border-box",
                    width: "97%",
                  }}
                >
                  <thead>
                    <tr>
                      <th>
                        {strings[pageTitle][language].MyOfflineActivitiesForms}
                      </th>
                      <th>
                        {
                          strings[pageTitle][language]
                            .MyOfflineActivitiesSection
                        }
                      </th>
                      <th>
                        {strings[pageTitle][language].MyOfflineActivitiesField}
                      </th>
                      <th>
                        {strings[pageTitle][language].MyOfflineActivitiesChoice}
                      </th>
                      <th>
                        {strings[pageTitle][language].MyOfflineActivitiesVal}
                      </th>
                      <th>
                        {strings[pageTitle][language].MyOfflineActivitiesUnit}
                      </th>
                      <th>
                        {
                          strings[pageTitle][language]
                            .MyOfflineActivitiesDuration
                        }
                      </th>
                      <th>
                        {strings[pageTitle][language].MyOfflineActivitiesNumAct}
                      </th>
                      <th>
                        {strings[pageTitle][language].MyOfflineActivitiesAht}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {offlineActivities &&
                      offlineActivities.map((activity) => {
                        return (
                          <tr>
                            <td>{activity.formName}</td>
                            <td>{activity.sectionName}</td>
                            <td>{activity.fieldName}</td>
                            <td>{activity.value}</td>
                            <td>{activity.valueCountOrSum}</td>
                            <td>{activity.unit}</td>
                            <td>
                              {formatMillisecondsToTime(activity.durationMs)}
                            </td>
                            <td>{activity.processesCount}</td>
                            <td>
                              {formatMillisecondsToTime(
                                activity.averageDurationMs
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="button-normal"
                  onClick={() => setShowOfflineModal(false)}
                >
                  OK
                </button>
              </Modal.Footer>
            </Modal>
            <YesNoModal
              handleShowModal={(show) => setShowLogoutModal(show)}
              handleYes={() => {
                handleAgentLogout();
              }}
              propShow={showLogoutModal}
            >
              Are you sure you want to logout?
            </YesNoModal>
            <IdleCodeContext.Provider
              value={{ currentIdleCode, setCurrentIdleCode, agentIdleCodes }}
            >
              <Outlet />
            </IdleCodeContext.Provider>
          </div>
        </div>
      ) : (
        <ChooseTenant redirectUrl={"/agent"} />
      )}
    </ErrorBoundary>
  );
}

export default AgentHomePage;
